/**
 * Determine if we should display the singular word or plural word.
 * This implies that a value between 0.1 and 0.4 should be singular (ceiled to 1).
 * Otherwise we round the value (1.1 to 1.4 will be singular but 1.5+ would be plural)
 * @param {number} value : input value
 */
export const getCountForPlural = (value: number) => value < 1 ? Math.ceil(value) : Math.round(value);
export const singularize = (word: string) => word ? word.slice(0, -1) : '';

/**
 * Returns the first letter of first and last name
 * @param {string} name
 */
export const getInitials = (name: string) => {
  if (!name) return '';
  const initials = name.match(/\b\w/g) || [];
  return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
};
export const getFirstTwoCapitalLetters = (str: string | null | undefined) => {
  if (!str) return '';
  const letters = str.match(/[A-Z]+/g);
  if (!letters) return '';
  return letters.join('').substring(0, 2);
};
export const normalizeString = (str: string) => str ? str.toUpperCase().trim() : '';
export const noLetters = (str: string) => /[a-zA-Z]/g.test(str);

// Capitalize the first letter of a string
export const capitalizeString = (str: string | number, preserve = true) => {
  if (typeof str !== 'string') return str.toString();
  let capitalized = str;
  if (!preserve) {
    capitalized = str.toLowerCase();
  }
  return `${capitalized.charAt(0).toUpperCase()}${capitalized.substring(1)}`;
};